<template>
  <div class="mobile-home">
    <CommonHeader v-if="!headerHidden" />
    <router-view />
    <Footer v-if="!hiddenBlock" />
    <FooterBanner v-if="!hiddenBlock" />
  </div>
</template>

<script>
import CommonHeader from "../../components/MobileComponents/CommonHeader";
import Footer from "../../components/MobileComponents/Footer";
import FooterBanner from "../../components/MobileComponents/FooterBanner";
import { weixinShare } from '../../utils/wxShare'

export default {
  name: "MobileHome",
  data() {
    return {
      headerExcludeList: ['/mobile/green-finance-award', '/mobile/green-finance-award-2023', '/mobile/green-finance-award-2024'],
      excludeList: [
        '/mobile/green-finance-award', '/mobile/green-finance-award-2023','/mobile/green-finance-award-2024', '/mobile/summit-meeting', '/mobile/summit-meeting-imgs', '/mobile/summit-meeting-awards'
      ]
    }
  },
  methods: {
    loadWx() {
      const path = this.$route.path;
      let descr = '';
      switch (path) {
        case '/mobile/summit-meeting-awards':
          descr = '由绿色金融60人论坛主办的“GF60绿色金融奖”于12月23日隆重揭晓';
          break;
        case '/mobile/summit-meeting':
          descr = '由昆明市人民政府、绿色金融60人论坛联合主办的“2022绿色金融国际峰会·滇池论坛”于12月23日盛大召开';
          break;
        case '/mobile/green-finance-award-2023':
          descr = '报名通道火热开启，点击“立即报名”按钮参与活动';
        break;
        case '/mobile/green-finance-award-2024':
          descr = '报名通道火热开启，点击“立即报名”按钮参与活动';
        break;
        default:
          descr = '绿色金融60人论坛（英文名为“Green Finance Forum of 60”、简称 “GF60”）是非营利性的国际化绿色金融交流平台，以上海金司南金融研究院为依托，汇聚全球绿色产业、金融专家，在气候变化与可持续发展领域拥有扎实的理论基础、深刻的洞察力和丰富的实践经验，围绕双碳价值实现、信息披露、法律标准、金融服务、风险防范，长期助力区域经济与绿色产业协同发展，为政策制定与监管、行业研究与实践提供开放交流平台，促进完善绿色金融体系，共同服务双碳战略产业长期健康发展。';
          break;
      }

      let image = '';
      switch (path) {
        case '/mobile/summit-meeting':
          image = 'https://gf60.org.cn/upload/owe/48e798a1506a484194f95911ecbee4d8.jpg';
          break;
        case '/mobile/summit-meeting-awards':
          image = 'https://gf60.org.cn/upload/owe/4930813170c6404f805da497ebf22a79.jpg';
          break;
        case '/mobile/green-finance-award-2023':
          image = 'https://gf60.org.cn/upload/owe/bb0b3c34c6684de1b166c271c2ff0426.jpg';
        break;
        case '/mobile/green-finance-award-2024':
          image = 'https://image.gf60.org.cn/upload/owe/a5634cb73d444d4aa234b1244fdaa732.jpg';
        break;
        default:
          image = 'https://gf60.org.cn/upload/owe/aeceac6fedf44bee867966e1257548e5.jpg';
          break;
      }

      let title = document.title;
      switch (path) {
        case '/mobile/summit-meeting':
          title = '2022绿色金融国际峰会·滇池论坛';
          break;
        case '/mobile/summit-meeting-awards':
          title = 'GF60绿色金融奖评选';
          break;
          case '/mobile/green-finance-award-2023':
          title = '2023年度“GF60绿色金融奖”';
          break;
          case '/mobile/green-finance-award-2024':
          title = '2024年度“GF60绿色金融案例”';
          break;
      }

      weixinShare({
        link: window.location.href,
        image,
        title,
        descr
      });
    }
  },
  computed: {
    hiddenBlock() {
      const _path = this.$route.path;
      return this.excludeList.includes(_path);
    },
    headerHidden() {
      const _path = this.$route.path;
      return this.headerExcludeList.includes(_path);
    }
  },
  components: {
    CommonHeader, Footer, FooterBanner
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler(v) {
        this.loadWx();
      }
    }
  },
}
</script>

<style lang="less">
@import "../../../src/common/theme.less";
.mobile-home {
  padding-bottom: 52px;
  margin: 0 auto;
  font-size: calc(@mobileFont * .28);
  //max-width: 750px;
  input {
    outline: none;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  .wrap-txt {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .txt-align {
    text-align: justify;
    word-break: break-word;
  }
  .en-txt-align {
    text-align: left;
    text-indent: 0 !important;
  }
  .link-tag-small {
    font-size: 12px;
    color: #037698;
    cursor: pointer;
    text-decoration: none;
  }
  .link-tag-lg {
    font-size: 14px;
    color: #037698;
    cursor: pointer;
  }
  .block {
    margin-bottom: 30px;
  }
  .cov-img {
    display: block;
    object-fit:cover;
  }
  .center-box {
    padding: 0 calc(@mobileFont * .55);
  }
  .banner {
    display: block;
    width: 100%;
  }
  .link-box {
    color: #037698;
    font-size: calc(@mobileFont * .2);
  }
}
</style>
